
import { Component, Vue } from 'vue-property-decorator';
import { I18n } from '@aws-amplify/core';
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Hub } from 'aws-amplify';
import {
  CognitoUserInterface,
  onAuthUIStateChange,
} from '@aws-amplify/ui-components';
import LayoutAuthentication from '@/layouts/LayoutAuthentication.vue';
import AmplifyI18n from '@/components/authentication/AmplifyI18n';
import AuthenticatorCustom from '@/components/authentication/AuthenticatorCustom.vue';
import LinkCorporate from '@/components/LinkCorporate.vue';
import SwitchLocale from '@/components/SwitchLocale.vue';

@Component({
  components: {
    AuthenticatorCustom,
    LinkCorporate,
    SwitchLocale,
    LayoutAuthentication,
  },
})
export default class Authentication extends Vue {
  loading = false;

  get authConfig(): any {
    const emailLabel = 'Email address';
    return {
      usernameAttributes: emailLabel,
      signUpConfig: {
        hideAllDefaults: true,
        signUpFields: [
          {
            label: emailLabel,
            key: 'username',
            required: true,
            displayOrder: 1,
            type: 'string',
          },
          {
            label: this.$t('registration.label.password'),
            key: 'password',
            required: true,
            displayOrder: 2,
            type: 'password',
          },
          {
            label: 'locale',
            key: 'locale',
            required: false,
            displayOrder: 3,
            type: 'string',
            value: this.$i18n.locale,
          },
        ],
      },
    };
  }

  get user(): CognitoUserInterface {
    return this.$store.state.auth.user;
  }

  get signedIn(): boolean {
    return this.$store.getters['auth/signedIn'];
  }

  async beforeCreate() {
    await this.$store.dispatch('auth/getUser');

    // If user is authenticated and redirect is set, do redirect immediately
    if (this.$store.getters['auth/signedIn']) {
      if (this.$route.query.redirect) {
        await this.$router.push(this.$route.query.redirect as string);
        return;
      }
    }

    // Register the event to be called when the authentication status changes
    AmplifyEventBus.$on('authState', async () => {
      setTimeout(() => {
        this.setLoadingListeners();
      }, 0);

      this.loading = false;
      // Removed handled by Hub in App.vue
      await this.$store.dispatch('auth/getUser');
    });
  }

  setLoadingListeners() {
    document.querySelectorAll('[class^=Button__button]').forEach((elem) => {
      elem.addEventListener('click', () => {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 5000);
      });
    });
  }

  beforeDestroy() {
    return onAuthUIStateChange;
  }

  mounted() {
    this.setSignUp();

    // Listen for responses from Cognito to disable the loader.
    Hub.listen('auth', () => {
      this.loading = false;
    });

    I18n.putVocabularies(AmplifyI18n);

    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        I18n.setLanguage(newLocale);
      },
      { immediate: true },
    );
  }

  // Set sign in or sign up manually, as the legacy component does not
  // have initialState.
  setSignUp() {
    if (this.$route.query.state !== 'signUp') {
      return;
    }
    setTimeout(() => {
      const link: any = document.querySelector(
        '[data-test="sign-in-create-account-link"]',
      );
      if (link) {
        link.click();
      }
    }, 0);
  }
}
